import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { unloadTech } from '../../../modules/projectModule/tech';
import { unloadTechRslt } from '../../../modules/projectModule/techRslt';
import TechListContainer from '../../../containers/projectmng/support/TechListContainer';
import TechAddModalContainer from '../../../containers/projectmng/support/TechAddModalContainer';
import TechEditStepperModalContainer from '../../../containers/projectmng/support/TechEditStepperModalContainer';

const TechSupportTemplate = () => {
  const dispatch = useDispatch();
  const { project } = useSelector(({ projectModule }) => ({
    project: projectModule.project.project,
  }));
  const [reqId, setReqId] = useState(null);
  const [type, setType] = useState('add');
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    setOpen(false);
    setType('add');
    setReqId(null);
    dispatch(unloadTech());
    dispatch(unloadTechRslt());
  };

  const selectedTech = (data) => {
    setReqId(data.reqUuid);
    setType('edit');
    setOpen(true);
  };

  if (!project) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        m: 1,
      }}
    >
      <TechListContainer selectedTech={selectedTech} />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          my: 1,
        }}
      >
        <Button
          variant="contained"
          color="info"
          onClick={handleOpen}
          sx={{ mr: 1 }}
        >
          신규지원 작성
        </Button>
      </Box>
      {type === 'add' ? (
        <TechAddModalContainer
          open={open}
          handleClose={handleClose}
          project={project}
        />
      ) : (
        <TechEditStepperModalContainer
          type={type}
          reqId={reqId}
          open={open}
          handleClose={handleClose}
          project={project}
        />
      )}
    </Box>
  );
};

export default TechSupportTemplate;
